<template>
  <div class="stat-wrapper">
    <section class="load-resolved" v-if="stat">
      <div class="chartTitle">
        <h3 class="chartTitle__text">تعداد پذیرنده‌ها</h3>
        <h4 class="chartTitle__number">
          {{ chart['all'].toLocaleString() }}
        </h4>
      </div>
      <div class="cmp-items-wrapper">
        <div class="chart">
          <doughnut
            :dataset="[chart['active'], chart['used'], chart['expired']]"
            :colors="['#c69d4e', '#777', '#333']"
            :size="150"
            :thickness="15"
            style="position:relative; bottom: 5px;"
          />
          <div class="chart__legend">
            <div class="chart__row">
              <span class="chart__value value--gold"
                >{{ chart['activePercent'] }}%</span
              >
              <h5 class="chart__title">پذیرنده فعال</h5>
            </div>
            <div class="chart__row">
              <span class="chart__value value--silver"
                >{{ chart['expiredPercent'] }}%</span
              >
              <h5 class="chart__title">پذیرنده غیرفعال</h5>
            </div>
          </div>
        </div>
        <div class="chart chart--hist">
          <div class="hist-wrapper">
            <div class="chart-row" v-for="bar in bars" :key="bar.id">
              <div class="chart-bar-row">
                <div class="chart-bar">
                  <i
                    :style="{
                      backgroundColor: bar['color'],
                      width: bar['width'] === '0%' ? '3px' : bar['width']
                    }"
                  />
                </div>
              </div>
              <div class="chart-row-stat">
                <h6>{{ bar['count'] }}</h6>
                <h5>{{ bar['title'] }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="load-pending" v-else>
      <img src="@img/vipon-loading.svg" />
    </section>
  </div>
</template>

<script>
import { computed, onBeforeUnmount, reactive, watch, ref } from 'vue'
import { useStore } from 'vuex'
import Doughnut from '@common/Doughnut'

export default {
  name: 'ReceiverStat',
  components: {
    Doughnut
  },
  setup() {
    const store = useStore()
    store.dispatch('fetchStat', { part: 'cashier' })
    const stat = computed(() => store.state.stat)

    /******************
     * Doughnut Maker *
     ******************/
    const chart = ref(null)
    const bars = reactive([])

    watch(stat, (stat) => {
      chart.value = {}
      // Init doughnut
      const all = stat['active'] + stat['expired']
      const activePercent = Math.round((stat['active'] / all) * 100)
      const expiredPercent = Math.round((stat['expired'] / all) * 100)

      chart.value['all'] = all
      chart.value['active'] = stat['active']
      chart.value['expired'] = stat['expired']
      chart.value['activePercent'] = activePercent
      chart.value['expiredPercent'] = expiredPercent

      // Init Bars
      bars[1] = {
        id: 1,
        count: stat['expired'].toLocaleString(),
        width: expiredPercent + '%',
        color: '#333',
        title: 'پذیرنده غیرفعال'
      }
      bars[0] = {
        id: 2,
        count: stat['active'].toLocaleString(),
        width: activePercent + '%',
        color: '#c69d4e',
        title: 'پذیرنده فعال'
      }
    })

    onBeforeUnmount(() => store.dispatch('clearStat'))
    return { stat, chart, bars }
  }
}
</script>

<style scoped>
.hist-wrapper .chart-row .chart-row-stat h6::after {
  content: '';
}
.chart--hist {
  margin-bottom: 0;
}
</style>
